export const stats = [
  { value: "400K+", label: "Thefts Caught Yearly" },
  { value: "30%", label: "Average Shrink Reduction" },
  { value: "20K+", label: "Stores Protected" },
  { value: "100%", label: "Remote Workforce" },
];

export const trustPartners = [
  {
    name: "NVIDIA Inception",
    logo: "https://i0.wp.com/panoptyc.com/wp-content/uploads/2025/01/nvidia-inception-program-badge-rgb-for-screen.jpg?fit=501%2C217&ssl=1",
  },
  {
    name: "AWS Partner",
    logo: "https://i0.wp.com/panoptyc.com/wp-content/uploads/2025/02/AWS-Partner.png?fit=553%2C451&ssl=1",
  },
  {
    name: "LPRC",
    logo: "https://i0.wp.com/panoptyc.com/wp-content/uploads/2025/02/download.png?fit=470%2C107&ssl=1",
  },
  {
    name: "365 Retail Markets",
    logo: "https://i0.wp.com/panoptyc.com/wp-content/uploads/2025/02/download.jpeg?fit=225%2C225&ssl=1",
  },
];

export const features = [
  {
    title: "Cashier Shrink",
    description: "AI-powered detection identifies cashier theft patterns including sweethearting, no-scans, and under-ringing across thousands of POS transactions daily.",
    highlight: "₹2.5L+ saved per store",
    icon: "ShoppingCart",
  },
  {
    title: "Self-Checkout Theft",
    description: "Our platform monitors self-checkout stations in real-time, catching skip-scans, ticket switching, and walkouts before losses accumulate.",
    highlight: "60% theft reduction",
    icon: "ScanLine",
  },
  {
    title: "Complete Visibility",
    description: "Retailers know shrink numbers but not where it comes from. Panoptyc pinpoints exact sources of loss with video evidence and analytics.",
    highlight: "30% shrink reduction",
    icon: "Eye",
  },
];

export const whyPanoptyc = [
  {
    title: "Cashier Shrink",
    description: "AI-powered detection identifies cashier theft patterns including sweethearting, no-scans, and under-ringing across thousands of POS transactions daily.",
    stat: "₹2.5L+ saved per store",
    icon: "ShoppingCart",
  },
  {
    title: "Self-Checkout Theft",
    description: "Our platform monitors self-checkout stations in real-time, catching skip-scans, ticket switching, and walkouts before losses accumulate.",
    stat: "60% theft reduction",
    icon: "AlertTriangle",
  },
  {
    title: "Complete Visibility",
    description: "Retailers know shrink numbers but not where it comes from. Panoptyc pinpoints exact sources of loss with video evidence and analytics.",
    stat: "30% shrink reduction",
    icon: "Eye",
  },
];

export const industries = [
  {
    title: "Retail Cashier",
    description: "POS transaction monitoring and cashier accountability across retail chains.",
    image: "https://images.unsplash.com/photo-1771575521357-f6c9237fe16f?auto=format&fit=crop&w=400&q=80",
  },
  {
    title: "Grocery",
    description: "Complete loss prevention for grocery stores from entrance to checkout.",
    image: "https://images.unsplash.com/photo-1710750483431-d8eb4312d971?auto=format&fit=crop&w=400&q=80",
  },
  {
    title: "Self-Checkout",
    description: "AI monitors every self-checkout transaction to detect skip-scans and fraud.",
    image: "https://images.unsplash.com/photo-1740150884358-5a254d7ae5de?auto=format&fit=crop&w=400&q=80",
  },
  {
    title: "Micro Markets",
    description: "Unattended retail spaces monitored 24/7 with smart video analytics.",
    image: "https://images.unsplash.com/photo-1765648496288-e1760f547711?auto=format&fit=crop&w=400&q=80",
  },
  {
    title: "Dining",
    description: "Protect dining establishments from inventory shrink and employee theft.",
    image: "https://images.unsplash.com/photo-1769485016826-a7d5bfe50119?auto=format&fit=crop&w=400&q=80",
  },
  {
    title: "Convenience Stores",
    description: "Round-the-clock surveillance for high-traffic convenience retail locations.",
    image: "https://images.unsplash.com/photo-1759153820384-12c9ddf8bd8d?auto=format&fit=crop&w=400&q=80",
  },
];

export const roleResponsibilities = [
  { text: "Monitor live and recorded video feeds from retail stores across the US", icon: "Monitor" },
  { text: "Identify suspicious activities, theft incidents, and policy violations", icon: "Eye" },
  { text: "Document and report incidents using Panoptyc's AI-powered platform", icon: "FileText" },
  { text: "Maintain strict confidentiality of all surveillance data and client information", icon: "Shield" },
  { text: "Analyze patterns and trends to help stores reduce shrink proactively", icon: "TrendingUp" },
  { text: "Collaborate with US-based loss prevention teams for incident resolution", icon: "Users" },
];

export const requirements = [
  {
    title: "Education",
    description: "Minimum 12th pass or Graduate degree",
    icon: "GraduationCap",
  },
  {
    title: "English",
    description: "Basic English reading and writing skills",
    icon: "BookOpen",
  },
  {
    title: "Internet",
    description: "Stable internet connection (minimum 10 Mbps)",
    icon: "Wifi",
  },
  {
    title: "Equipment",
    description: "Own laptop or desktop with webcam",
    icon: "Monitor",
  },
  {
    title: "Night Shifts",
    description: "Comfortable working US night hours (IST)",
    icon: "Moon",
  },
  {
    title: "Attention",
    description: "Strong attention to detail and observation skills",
    icon: "Focus",
  },
];

export const benefits = [
  {
    title: "₹35,000/month",
    description: "Competitive salary paid on time, every month",
    icon: "IndianRupee",
  },
  {
    title: "100% Work From Home",
    description: "No commute. Work from anywhere in India",
    icon: "Home",
  },
  {
    title: "Free Training",
    description: "Comprehensive paid training on our AI platform",
    icon: "BookOpen",
  },
  {
    title: "Career Growth",
    description: "Clear path to Team Lead and Management roles",
    icon: "TrendingUp",
  },
  {
    title: "Supportive Team",
    description: "Friendly team culture with 24/7 support from managers",
    icon: "Users",
  },
  {
    title: "Cutting-Edge Tech",
    description: "Work with the latest AI and video analytics technology",
    icon: "Cpu",
  },
];

export const steps = [
  {
    number: "01",
    title: "Apply Online",
    description: "Fill the application form with your basic details. It only takes 2 minutes.",
  },
  {
    number: "02",
    title: "Complete Profile",
    description: "Set up your profile with personal details, education info, and passport photo.",
  },
  {
    number: "03",
    title: "Sign Agreement",
    description: "Review and sign the employment agreement digitally on our platform.",
  },
  {
    number: "04",
    title: "Start Working",
    description: "Receive your employee code and begin your paid training immediately.",
  },
];

export const howToJoinSteps = [
  {
    step: "01",
    title: "Apply Online",
    description: "Fill the application form with your basic details. It only takes 2 minutes.",
  },
  {
    step: "02",
    title: "Complete Profile",
    description: "Set up your profile with personal details, education info, and passport photo.",
  },
  {
    step: "03",
    title: "Sign Agreement",
    description: "Review and sign the employment agreement digitally on our platform.",
  },
  {
    step: "04",
    title: "Start Working",
    description: "Receive your employee code and begin your paid training immediately.",
  },
];

export const testimonials = [
  {
    text: "Before Panoptyc, investigating potential theft meant retrieving DVRs and spending hours reviewing footage. Now our supervisors can focus on growing our business instead of chasing shrink.",
    name: "Jeff Hemp",
    role: "Store Operations Director · Verified Customer",
    initials: "JH",
  },
  {
    text: "Panoptyc's AI platform has transformed how we handle loss prevention. The real-time alerts and video evidence make it easy to take action immediately. We've seen a 35% reduction in shrink.",
    name: "Sarah Mitchell",
    role: "VP Loss Prevention · Retail Chain",
    initials: "SM",
  },
  {
    text: "The remote analysts at Panoptyc are incredibly thorough. They catch things our in-store cameras alone never would. It's like having an extra set of expert eyes on every transaction.",
    name: "David Chen",
    role: "Regional Manager · Grocery Network",
    initials: "DC",
  },
];

export const customers = ["Bernick's", "Premier Canteen", "Mattress Firm", "FreshMart", "QuickStop"];

export const faqItems = [
  {
    question: "What does a Remote Video Surveillance Analyst do?",
    answer: "You'll monitor live and recorded video feeds from retail stores across the US using Panoptyc's AI-powered platform. Your job is to identify theft, suspicious activities, and policy violations, then document and report them.",
  },
  {
    question: "What are the work hours?",
    answer: "This is a full-time position with night shifts aligned with US retail store hours. Shifts are approximately 8 hours, typically starting in the evening IST. Exact schedules are discussed during onboarding.",
  },
  {
    question: "Do I need any prior experience?",
    answer: "No prior surveillance experience is required. We provide comprehensive free training on our AI platform. You need basic English skills, attention to detail, and a stable internet connection.",
  },
  {
    question: "What equipment do I need?",
    answer: "You need your own laptop or desktop computer with a webcam and a stable internet connection (minimum 10 Mbps). The company provides all necessary software and platform access.",
  },
  {
    question: "When will I receive my salary?",
    answer: "Salary of ₹35,000 is paid monthly by the 5th of each subsequent month directly to your bank account.",
  },
  {
    question: "Is this a legitimate work-from-home job?",
    answer: "Yes, Panoptyc is a US-based company trusted by 20,000+ retail stores, backed by NVIDIA and AWS. We have a proven track record of catching 400,000+ thefts annually. You can verify us at panoptyc.com.",
  },
];
